import { AnalyticsEventNameType } from "@coeff/api";
import { useEffect } from "react";

import { useEventManagerContext } from "../globals/contexts";

import { MIN_LOADING_TIME } from "./constants";

interface UseOnScreenTimeParams {
  name: string;
  enable?: boolean;
  dataSourceType?: string;
}

export const useCaptureLoadingTime = (params: UseOnScreenTimeParams) => {
  const context = useEventManagerContext();
  const { name: screen, enable = true, dataSourceType } = params;

  useEffect(() => {
    const startTime = Date.now();

    return () => {
      const duration_ms = Date.now() - startTime;
      if (enable && duration_ms > MIN_LOADING_TIME && context && context.track) {
        // convert milliseconds to seconds and round to 2 decimal places
        const duration = Number((duration_ms / 1000).toFixed(2));
        const duration_rounded = Math.round(duration_ms / 1000);
        const payload = {
          screen,
          duration,
          duration_rounded,
          ...(dataSourceType ? { data_source: dataSourceType } : {}),
        };
        context?.track(AnalyticsEventNameType.LoaderOnScreenTime, payload);
      }
    };
  }, [screen, enable, context, dataSourceType]);
};
